import Component from './MyLocation.container';

export default Component;
